
import React from 'react';
const ArrowRight = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="none"
    {...props}
  >
    <path fill='currentColor' stroke='currentColor' d="M 27 128 a 12.0003 12.0003 90 0 0 12 12 H 186.0293 l -51.5147 51.5147 a 12.0001 12.0001 90 0 0 16.9707 16.9707 l 72 -72 a 11.9997 11.9997 90 0 0 0 -16.9707 l -72 -72 a 12.0001 12.0001 90 0 0 -16.9707 16.9707 L 186.0293 116 H 39 A 12.0003 12.0003 90 0 0 27 128 Z" />
  </svg>
);


export default ArrowRight;
